<template>
    <div>
        <config-main-title>
            Cerimonial Check-In
        </config-main-title>

        <div class="row">
            <div class="col col-12">
                <az-input
                    ref="pesquisa"
                    icon="fa fa-search"
                    placeholder="Pesquisar Paciente..."
                    v-model="search" 
                    @input="buscar()">
                    <template v-slot:buttonposb>
                        <div class="input-group-append" v-if="search">
                            <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="search = ''">
                                <i class="fa fa-eraser" aria-hidden="true"></i>
                            </button>
                        </div>
                    </template>
                </az-input>

                <div class="progress mt-1 mb-3">
                    <div class="indeterminate" v-if="$store.state.loading"></div>
                    <div class="determinate" v-else></div>
                </div>
            </div>
        </div>

        <table class="table bg-white table-responsive-md" v-if="dados && dados.lista && dados.lista.length">
            <tbody>
                <template v-for="(item, idx) in dados.lista">
                    <tr :key="idx" v-if="true">
                        <td>
                            <h5 class="mb-0" v-if="item.id_atendimento">
                                <span class="badge badge-success">
                                    Atendido
                                </span>
                                <div class="small text-muted">
                                    {{ item.atendimento.dt_inicio.substr(11,5) }}
                                </div>
                            </h5>
                            <h5 class="mb-0" v-else-if="item.dt_checkin">
                                <button type="button" class="btn btn-outline-info btn-sm" @click="realizar_check_in(item)">
                                    Check-In Realizado
                                </button>
                                <div class="small text-muted">
                                    {{ item.dt_checkin.substr(11,5) }}
                                </div>
                            </h5>
                            <div v-else>
                                <button type="button" class="btn btn-outline-success btn-sm" @click="realizar_check_in(item)">
                                    Realizar Check-In
                                </button>
                            </div>
                            <small>
                                <a href="#" class="text-danger card-link" @click.prevent="remover_checkin(item)"
                                    v-if="item.dt_checkin && item.st_checkin_origem == 'cerimonial' && !item.id_atendimento && !$store.state.loading">
                                    Remover
                                </a>
                            </small>
                        </td>
                        <td>
                            <div> 
                                {{ item.nome_paciente }}
                                <span v-if="item.fl_preferencial" data-toggle="tooltip" data-placement="top" title="Preferencial">
                                    <i class="fab fa-product-hunt"></i>
                                </span>
                            </div>
                            <div class="small text-muted" v-if="item.plano">
                                {{ item.plano.search }}
                            </div>
                            <div class="text-muted">
                                <span>
                                    <i class="fas fa-male mx-2" v-if="item.sexo_paciente == 'M'"></i>
                                    <i class="fas fa-female mx-2" v-if="item.sexo_paciente == 'F'"></i>
                                    <template v-if="item.nascimento_paciente">
                                        <i class="fas fa-birthday-cake mr-1"></i>
                                        <small>
                                            {{ $util.getFormatDate(item.nascimento_paciente) }}
                                        </small>
                                    </template>
                                </span>
                                <span v-if="item.cpf_paciente" class="ml-3 small">
                                    CPF: {{ $util.formatMask(item.cpf_paciente, 'cpf') }}
                                </span>
                            </div>
                        </td>
                        <td>
                            <div v-if="item.nome_local" class="small">
                                {{ item.nome_local }}
                            </div>
                            <div>
                                {{ item.procedimento.search }}
                            </div>
                            <div class="small text-muted">
                                <span class="mr-3">
                                    {{ item.dt_inicio.substr(11,5) }} 
                                </span>
                                {{ item.medico.search }}
                            </div>
                        </td>
                        <td>
                            <div v-if="item.telefone_paciente">
                                <i class="fa fa-phone fa-fw  mr-1" aria-hidden="true"></i>
                                <small>
                                    {{ $util.formatMask(item.telefone_paciente, item.telefone_paciente.length == 11 ? 'cel' : 'tel') }}
                                </small>
                            </div>
                            <div v-if="item.celular_paciente">
                                <i class="fas fa-mobile-alt fa-fw mr-1"></i>
                                <small>
                                    {{ $util.formatMask(item.celular_paciente, item.celular_paciente.length == 11 ? 'cel' : 'tel') }}
                                </small>
                            </div>
                            <div v-if="item.email_paciente">
                                <i class="far fa-envelope fa-fw mr-1"></i>
                                <small>
                                    {{ item.email_paciente }}
                                </small>
                            </div>
                        </td>
                        <td>
                            <div class="lead">
                                {{ item.codigo_reserva }}
                            </div>
                            <div>
                                <a href="#" @click.prevent="printEtiqueta(item)">
                                    <i class="fa-solid fa-tag"></i>
                                </a>
                            </div>
                        </td>
                    </tr>
                    <tr :key="'E' + idx" v-if="item.expresso">
                        <td colspan="5">
                            {{ item.expresso }}
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>

        <az-empty-state msg="Nenhum paciente encontrado." v-if="search && dados && dados.lista && !dados.lista.length" />

        <template v-if="!search">

            <template v-if="adicoes && adicoes.length">
                <button type="button" class="btn btn-outline-primary mb-3 mr-1" @click="selecionarAdicao(adicao)" v-for="(adicao, iax) in adicoes" :key="iax">
                    {{ adicao.st_titulo }}
                </button>
            </template>

            <button type="button" class="btn btn-outline-primary mb-3" @click="ler_qrcode = !ler_qrcode">
                {{ ler_qrcode ? 'Fechar Leitura de QRCode' : 'Leitura de QRCode' }}
            </button>

            <div class="row" v-if="ler_qrcode">
                <div class="col col-12 col-md-6">
                    <qrcode-stream @decode="onDecode"></qrcode-stream>
                </div>
            </div>

        </template>

        <check-in ref="chk" :lista="dados ? dados.lista : null" @refresh="load()" />

        <!-- Emitir Etiqueta -->
        <emitir-etiqueta ref="etiqueta" />

        <!-- Modal de Novo CheckIn Outro -->
        <div class="modal fade" id="novoCheckInOutroModal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog2 modal-dialog-scrollable" role="document">
                <div class="modal-content modal-content2">
                    <div class="modal-header">
                        <span>Novo Atendimento</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <marcacao
                            v-if="obter_unidade_recepcao()"
                            ref="marcacao"
                            modalName="novoCheckInOutroModal"
                            :data="$util.hoje()"
                            :hora="refHora"
                            :adicao_outro="adicao_outro"
                            :id_unidade_operacao="obter_unidade_recepcao().id_unidade_operacao"
                            :id_recepcao="obter_unidade_recepcao().id_recepcao"
                            :tem_atend_outro="true"
                            @refresh="concluir_marcacao"></marcacao>
                    </div>
                </div>
            </div>
        </div>
        <!-- Fim Modal de Novo CheckIn Outro -->
    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import ConfigMainTitle from '../../cadastros/shared/ConfigMainTitle.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import { QrcodeStream } from 'vue-qrcode-reader';
import CheckIn from './CheckIn.vue';
import Marcacao from "../callcenter/Marcacao.vue";
import EmitirEtiqueta from '../../shared/EmitirEtiqueta.vue';

export default {
    data() { 
        return { 
            search:  "", 
            search_timeout: null, 
            dados: null, 
            canceltoken: null, 
            marcacao: null, 
            ler_qrcode: false, 
            tipo_atendimento: 'N',
            faz_checkin_outros: this.$util.getCookie('faz-chk-out') == 'N' ? false : true, 
            refHora: "", 
            adicao_outro: null, 
        }
    },

    components: { 
        AzInput,
        ConfigMainTitle,
        AzEmptyState, 
        QrcodeStream, 
        CheckIn, 
        Marcacao, 
        EmitirEtiqueta, 
    },

    computed: { 

        adicoes: function () { 
            let recep = this.$util.recepcao();

            return recep ? recep.adicoes.filter(item => item.st_tipo && item.st_tipo != 'A')
                .filter(item => !item.fl_preferencial) : [];
        }

    },

    methods: { 
        printEtiqueta (marcacao) {
            this.$refs.etiqueta.emitir('marcacao', marcacao);
        },

        concluir_marcacao (item) {
            console.log(item);

            this.$toast.add({ 
                severity: "success",
                summary: "Atenção",
                detail: 'Inclusão realizada.',
                life: 3000
            });

            $('.modal').modal('hide');
        },

        selecionarAdicao (adicao) { 
            this.refHora = this.$util.agora().slice(0,5);
            this.adicao_outro = adicao;
            this.$refs.marcacao.reiniciar();
            this.$refs.marcacao.startFluxo(3);
            
            $('#novoCheckInOutroModal').modal('show');

            this.$nextTick(() => { 
                if ( this.$refs.marcacao && this.$refs.marcacao.$refs.visita ) { 
                    this.$refs.marcacao.$refs.visita.selecionarAdicao(adicao, true);
                }
            });
        },

        lista_outros (marcacao) { 
            if ( !this.dados && !this.dados.lista )
                return [];
            
            return this.dados.lista.filter(item => item.id_marcacao != marcacao.id_marcacao
                && !marcacao.dt_checkin 
                && ( marcacao.id_paciente || marcacao.id_cadastro_temporario ) 
                && ( ( marcacao.id_paciente && marcacao.id_paciente == item.id_paciente )
                    || ( marcacao.id_cadastro_temporario && marcacao.id_cadastro_temporario == item.id_cadastro_temporario ) ) );
        },

        remover_checkin (item) { 
            this.$refs.chk.remover_checkin(item);

            /*
            if ( !confirm('Confirma a remoção check-in realizado?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'marcacoes',
                func: 'cerimonial_remover',
                dados: { 
                    id_marcacao: item.id_marcacao,
                },
                reload: true,
                toast: true, 
            });
            */
        },

        onDecode (decodedString) {
            this.search = decodedString;
        },

        buscar() { 
            this.$store.commit("loading", true);

            if (this.search_timeout) clearTimeout(this.search_timeout);

            this.search_timeout = setTimeout(() => {
                this.load(false);
                this.search_timeout = null;
            }, 300);
        },

        obter_unidade_recepcao() { 
            let id_unidade_operacao = this.$util.getCookie('id_unidade_operacao');
            let id_recepcao = this.$util.getCookie('id_recepcao');
            const unidade = this.$store.state.unidade;

            if ( unidade && unidade.unidade_operacaos && unidade.unidade_operacaos.length == 1 ) { 
                id_unidade_operacao = unidade.unidade_operacaos[0].id_unidade_operacao;

                if ( unidade.unidade_operacaos[0].recepcaos.length == 1 ) { 
                    id_recepcao = unidade.unidade_operacaos[0].recepcaos[0].id_recepcao;
                }
            }

            return { 
                id_unidade_operacao: id_unidade_operacao,
                id_recepcao: id_recepcao,
            };
        },

        load() { 

            if ( !this.search ) { 
                this.dados = null;
                this.$store.commit("loading", false);
                return;
            }

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            this.canceltoken = this.axios.CancelToken.source();

            const unidade_recepcao = this.obter_unidade_recepcao();

            this.$util.load(this, { 
                service: 'marcacoes',
                func: 'cerimonial',
                parms: { 
                    search: this.search, 
                    ...unidade_recepcao, 
                    canceltoken: this.canceltoken, 
                },
            });
        },

        realizar_check_in(marcacao) { 
            this.$refs.chk.realizar_check_in(marcacao);

            /*
            this.marcacao = null;
            
            this.$nextTick(() => { 
                this.marcacao = marcacao;
                this.tipo_atendimento = this.marcacao.fl_preferencial ? 'P' : 'N';
                
                $('#confirmarCheckInModal').modal('show');
            });
            */
        },

        confirmar() { 
            const unidade_recepcao = this.obter_unidade_recepcao();

            this.$util.setCookie('faz-chk-out', this.faz_checkin_outros ? 'S' : 'N');

            let outros = this.faz_checkin_outros 
                ? this.lista_outros(this.marcacao).map(item => item.id_marcacao)
                : [];

            this.$util.atualizar(this, { 
                service: 'marcacoes',
                func: 'cerimonial_checkin',
                dados: { 
                    id_marcacao: this.marcacao.id_marcacao, 
                    ...unidade_recepcao, 
                    tipo_atendimento: this.tipo_atendimento, 
                    outros: outros, 
                },
                modal: 'confirmarCheckInModal',
                toast: true,
                callback: res => { 

                    if ( res && res.expresso ) { 
                        this.marcacao.expresso = res.expresso;
                        this.marcacao.dt_checkin = res.dt_checkin;
                        this.marcacao.fl_preferencial = res.fl_preferencial;
                        this.$forceUpdate();
                    } else { 
                        this.load();
                    }

                    if ( process.env.VUE_APP_GTAG ) { 

                        let action = 'check-in-cerimonial';
                        let label = this.marcacao.id_marcacao;
                        
                        this.$gtag.event(action, {
                            'event_category': window.redir,
                            'event_label': label,
                            'value': 1
                        });

                    }

                }
            });
        }
    },

    mounted() { 
        if ( this.$route.path == '/cerimonial' ) { 
            this.$store.commit("setBreadcrumb", [
                { name: "Cerimonial Check-In", path: "/cerimonial" }
            ]);    
        } else { 
            this.$store.commit("setBreadcrumb", [
                { name: "Recepção", path: "/recepcao" },
                { name: "Cerimonial Check-In", path: "/recepcao/checkin" }
            ]);
        }

        if ( this.$refs['pesquisa'] ) { 
            this.$refs['pesquisa'].$refs.input.focus ();
        }
    }

}
</script>